<kendo-panelbar>
  <kendo-panelbar-item [expanded]="false">
    <ng-template kendoPanelBarItemTitle>
      <div class="panelbar-header">
        <div class="panelbar-title">Reject Reasons</div>
        <div class="panelbar-subtitle">If you are rejecting a form, fill out optional reject reasons</div>
      </div>
    </ng-template>
    <ng-template kendoPanelBarContent>
      @if (formType === 'POLST') {
        <div>
          @for (r of polstRejectReasons; track r) {
            <div>
              <div [style.padding.px]="10" >
                <label><input type="checkbox" (change)="onRejectReasonChecked(r.text, $event)" kendoCheckBox />
                  {{r.text}}
                </label>
              </div>
            </div>
          }
        </div>
      }
      @if (formType !== 'POLST') {
        <div>
          @for (r of adRejectReasons; track r) {
            <div>
              <div [style.margin-top.px]="10" [style.padding.px]="10" >
                <label><input type="checkbox" (change)="onRejectReasonChecked(r.text, $event)" kendoCheckBox />
                  {{r.text}}
                </label>
              </div>
            </div>
          }
        </div>
      }
      <form [formGroup]="rejectReasonsForm" [style.margin-top.px]="10" [style.padding.px]="10" >
        <kendo-floatinglabel text="Reject Reasons" [style.margin-bottom.px]="10">
          <kendo-textarea style="width: 200%" [rows]="5" formControlName="freeText" (input)="getRejectReasonsValue()"></kendo-textarea>
        </kendo-floatinglabel>
      </form>
    </ng-template>
  </kendo-panelbar-item>
</kendo-panelbar>
